<div class="chart-wrapper">
    <canvas baseChart
        [datasets]="doughnutChartData"
        [labels]="doughnutChartLabels"
        [type]="doughnutChartType"
        [legend]="false">
    </canvas>
</div>